module.exports = __webpack_public_path__ + "media/images/icons/country_flags/eu-c9d8d63e107e62b812c8cb4eaffb5da5.svg";